<template>
	<div class="lm-card-preview"
		:class="DOMClass"
	>
		<template v-if="!card.empty">
			<div class="card-background" v-if="!frameOnly" />
			<div class="card-frame">
				<template v-if="frameOnly">
					<div class="card-type-label">
						<img :src="getTypeImg(card.type)" alt="">
					</div>
					<div class="r5-icon">
						<img :src="iconURL('/f/f3/Star_rank.png')" alt="">
					</div>
				</template>
				<div class="card-figure" @click="$emit('frame-click')">
					<img :src="iconURL(card.icon)" alt="">
				</div>
			</div>
			<template v-if="!frameOnly">
				<div class="card-info">
					<div class="card-type-label">
						<img :src="getTypeImg(card.type)" alt="">
					</div>
					<div class="r5-btn" @click.stop="toggleCardR5(i)">
						<div class="r5-btn-labels">
							<div>5</div>
							<div>0</div>
						</div>
						<div class="r5-btn-slider">
							<img :src="iconURL('/f/f3/Star_rank.png')" alt="">
						</div>
					</div>
				</div>
				<div v-if="card.skills.length" class="card-skills">
					<loadout-card-skill
						v-for="(skill, skillIndex) in card.skills" :key="skillIndex"
						:view="defaultSkillView"
						:skill="skill"
					/>
				</div>
			</template>
		</template>
		<slot v-else />
	</div>
</template>

<script>
import LoadoutCardSkill from '@/components/LoadoutCardSkill.vue';

import { cardHeld } from '@/utils/LoadoutList';

const RANKS = {
	0: 'B',
	1: 'A',
	2: 'S'
};

const TYPES_LABEL_SRCS = {
	0: '/6/66/Card_Red.png',
	1: '/0/0e/Card_Yellow.png',
	2: '/1/13/Card_Blue.png',
	3: '/6/6c/Card_Green.png'
};

export default {
	name: 'loadout-card',
	props: {
		frameOnly: {
			type: Boolean,
			default: false
		},
		defaultSkillView: {
			type: String,
			default: 'label'
		},
		card: {
			type: Object,
			required: true
		}
	},
	components: {
		LoadoutCardSkill
	},
	computed: {
		cardHeld() {
			return cardHeld.value;
		},
		DOMClass() {
			return this.card.empty
				? { empty: true }
				: {
					[`rank-${RANKS[this.card.rank]}`]: true,
					'is-r5': this.card.r5,
					'frame-only': this.frameOnly
				};
		}
	},
	methods: {
		getTypeImg(type) {
			if (typeof(type) == 'string')
				type = 'RYBG'.indexOf(type);
			return this.iconURL(TYPES_LABEL_SRCS[type]);
		},
		iconURL(pathToIcon) {
			return `https://static.wikia.nocookie.net/rockman_x_dive/images${pathToIcon}`;
		},
		toggleCardR5() {
			this.$emit('r5-changed');
		}
	}
};
</script>

<style lang="scss">
.lm-card-preview {
	display: flex;
	width: 100%;
	height: 108px;
	position: relative;
	&:not(.empty) {
		border-radius: 5px;
		background: #0002;
		box-shadow: inset 2px 2px 8px black;
		overflow: hidden;
	}
	&:not(:last-child) {
		margin-bottom: 10px;
	}
	>:not(.card-background) {
		z-index: 1;
	}
	.card-bg-text {
		position: absolute;
		inset: 0;
		z-index: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 60px;
		font-weight: bold;
		color: rgba(35, 67, 126, 0.8);
		background-clip: text;
	}
	.card-frame {
		width: 100px;
		min-width: 100px;
		height: 100%;
		padding-bottom: 0;
	}
	.card-info {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 40px;
		min-width: 40px;
		padding: 5px 2px;
		.card-type-label {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 40px;
			height: 40px;
			img {
				width: 30px;
				height: 30px;
			}
		}
		.r5-btn {
			color: white;
			display: flex;
			font-style: italic;
			flex: auto;
			margin: 2px;
			cursor: pointer;
			.r5-btn-labels {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				padding: 4px 0;
			}
			.r5-btn-slider {
				border: 1px solid #fff7;
				width: 10px;
				background: #424242;
				border-radius: 500px;
				margin: 10px;
				margin-right: 2px;
				position: relative;
				>img {
					transition: all ease-out 150ms;
					position: absolute;
					transform: translate(-50%, -50%);
					top: 0;
					left: 50%;
					filter: grayscale(0);
					width: 20px;
				}
			}
		}
	}
	&:not(.is-r5) {
		&.frame-only .r5-icon,
		.card-info .r5-btn .r5-btn-slider > img {
			filter: grayscale(1);
		}
		.card-info .r5-btn .r5-btn-slider > img {
			top: 100%;
		}
	}
	.card-skills {
		display: flex;
		flex-direction: column;
		flex: auto;
		overflow: hidden;
	}
	&.frame-only .card-frame {
		.card-type-label,
		.r5-icon {
			position: absolute;
			left: -2px;
			z-index: 1;
			width: 25px;
			height: 25px;
		}
		.card-type-label {
			top: -2px;
		}
		.r5-icon {
			bottom: -2px;
			>img {
				width: 100%;
				height: 100%;
			}
		}
	}
}
</style>
